<a class="skv-nav-link" [target]="target" [href]="href">
    <ng-content></ng-content>
    <ng-container *ngIf="external"> (nytt fönster)</ng-container>
    <svg *ngIf="icon" focusable="false" class="skv-icon skv-icon--inline">
        <use [attr.xlink:href]="icon"></use>
    </svg>
</a>